module.exports = __webpack_public_path__ + "img/photo.e9dde21d.png";